import React, { useEffect } from "react";
import { useOutletContext, useParams } from "react-router";
import { useAuth, useInterviewResponse } from "hooks";
import { Spinner } from "components/Loader";
import { MessagesError } from "components/Messages";
import { VideoInterviewFlow } from "components/VideoPresentation";
import { Grid, PageWrapper } from "components/Containers";
import { Helmet } from "react-helmet";
import Card from "components/Card";
import { ProfilePreferences, ProfileProgress } from "components/Profile";
import { SquadsHighlight } from "components/Squads";

/**
 * Interview Response Page
 */
const InterviewResponse = () => {
  const { uuid } = useParams();
  const { isMember } = useAuth();
  const { data, loading, error } = useInterviewResponse({ uuid, enabled: true });

  // Outlet context MAY or MAY NOT include setHideFooter
  const outletContext = useOutletContext() || {};
  const { setHideFooter } = outletContext;
  const mainColEnd = isMember ? 9 : 13;

  useEffect(() => {
    if (typeof setHideFooter === "function") {
      setHideFooter(true);
      return () => setHideFooter(false); // restore on exit
    }
  }, [setHideFooter]);

  if (loading) {
    return (
      <Grid topMargin>
        <Grid.col start={1} end={13}>
          <Spinner />
        </Grid.col>
      </Grid>
    );
  }

  if (error) {
    return <MessagesError />;
  }

  return (
    <PageWrapper>
      <Helmet>
        <title>{data.interview.name}</title>
      </Helmet>
      <Grid topMargin>
        <Grid.col start={1} end={mainColEnd}>
          <VideoInterviewFlow
            title={data.interview.name}
            introVideoUrl={data.interview.introVideoUrl}
            questions={data.interview.questions}
            interviewId={data.interview.id}
            {...data}
          />
        </Grid.col>
        {isMember && (
          <Grid.col start={9} end={13}>
            <Grid>
              <Grid.col start={1} end={13}>
                <Card>
                  <ProfileProgress id={data?.profileId} />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <ProfilePreferences id={data?.profileId} />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <SquadsHighlight profileId={data?.profileId} />
                </Card>
              </Grid.col>
            </Grid>
          </Grid.col>
        )}
      </Grid>
    </PageWrapper>
  );
};

export default InterviewResponse;
